import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { formatTelNumber } from './format-tel-number'

// 日本の国コード
const region = 'JP'

export const useValidationForm = ({
  initFormState,
  defaultFormState,
  _submitHandler,
}) => {
  const {
    watch,
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: initFormState || defaultFormState,
  })

  const watchFileds = watch()

  const [submitting, setSubmitting] = useState(false)

  const convertDomesticNumber = (value) => {
    if (!value) return false

    const countryCode = /^\+81/

    if (value.match(countryCode)) {
      return formatTelNumber('0' + value.slice(3))
    }
  }

  const submitHandler = useCallback(async () => {
    if (submitting || !_submitHandler) return

    setSubmitting(true)
    const values = await getValues()
    await _submitHandler(values)
    setSubmitting(false)
  }, [_submitHandler])

  const validTelNumber = useCallback((value) => {
    // 電話番号の有効性チェック
    return isValidPhoneNumber(value, region)
  }, [])

  return {
    control,
    handleSubmit,
    errors,
    setValue,
    watchFileds,
    submitHandler,
    validTelNumber,
    convertDomesticNumber,
  }
}
